import React, {useEffect, useState} from 'react';
import _ from "lodash";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import {
    DESIGN_INFO_FILTER_FIELDS_FOR_PRODUCTS,
    DESIGN_INFO_KEYS
} from "../../../shopify/constants/design-info.constant";
import {getDataFromLocalStorage} from "../../../common/utils/local-storage-util";
import DesignInfoFilters from "../../../shopify/components/design-info/design-info-filters";
import ParentProductDetail from "../../../pod/components/parent-product/edit-parent-product/parent-product-detail";
import {getAllTags} from "../../../common/services/tag-data-service";
import {
    searchParentProducts
} from "../../../pod/services/parent-product-data-service";
import {getDefaultPod} from "../../../pod/services/pod-data-service";
import {preparePodParentProductsFilters} from "../../utils/pod-parent-product-util";

const defaultFilterCriteria: any = {};


const ParentProductsList = () => {
    const [initialStep, setInitialStep] = useState(true);
    const [parentProductsList, setParentProductsList] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(defaultFilterCriteria);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);
    const [allDesignInfo, setAllDesignInfo] = useState(null);
    const [selectedParentProduct, setSelectedParentProduct] = useState(null);
    const [allTags, setAllTags] = useState([]);
    const [parentProduct, setParentProduct] = useState(null);
    const [podDetail, setPodDetail] = useState(null);

    useEffect(() => {
        if (initialStep) {
            setInitialStep(false);
            getDefaultPodDetail();
            getTagsList();
        }
    }, [initialStep]);

    const getTagsList = async () => {
        const tagsListResult = await getAllTags();
        setAllTags(tagsListResult);
    }

    const getDefaultPodDetail = async () => {
        setDataFetchInProgress(true);
        const podListResult = await getDefaultPod();
        const podDetailResult = podListResult[0];
        podDetailResult.filters = preparePodParentProductsFilters(podDetailResult);
        setAllDesignInfo(podDetailResult);

        const allParentProducts = _.orderBy(podDetailResult?.filters?.parent?.options, ['label'], ['asc']);
        setParentProductsList(allParentProducts);
        setSelectedParentProduct(allParentProducts[0]);

        setDataFetchInProgress(false);

        const existingFilters = getDataFromLocalStorage(DESIGN_INFO_KEYS.PRODUCTS_LIST_FILTERS);
        setFilterCriteria(existingFilters || defaultFilterCriteria);
    }

    const getParentProductList = async () => {
        setDataFetchInProgress(true);
        const existingAllDesignInfo = {...allDesignInfo};
        const existingFilterCriteria = {...filterCriteria};

        const allParentProducts = existingAllDesignInfo?.filters?.parent?.options;
        let filteredParentProducts = allParentProducts;

        if (!_.isEmpty(existingFilterCriteria)) {
            filteredParentProducts = _.filter(allParentProducts, existingFilterCriteria);
        }

        filteredParentProducts = _.orderBy(filteredParentProducts, ['label'], ['asc']);
        setParentProductsList(filteredParentProducts);

        if (filteredParentProducts?.length > 0) {
            setSelectedParentProduct(filteredParentProducts[0]);
        } else {
            setSelectedParentProduct(null);
        }

        setDataFetchInProgress(false);
    }

    useEffect(() => {
        getParentProductList();
    }, [filterCriteria]);

    const refreshParentProductList = async () => {
        await getParentProductList();
    }

    useEffect(() => {
        if (selectedParentProduct) {
            getParentProductDetail(selectedParentProduct);
        }
    }, [selectedParentProduct]);

    const getParentProductDetail = async (currentParentProduct) => {
        setDataFetchInProgress(true);

        if (currentParentProduct?.product_id) {
            const searchCriteriaList = [];
            searchCriteriaList.push({field: 'name', condition: '==', value: currentParentProduct?.key});
            const parentProductListResult = await searchParentProducts(searchCriteriaList);

            setParentProduct(parentProductListResult[0]);
        } else {
            setParentProduct(null);
        }

        setDataFetchInProgress(false);
    }

    return (
        <>

            <div className="flex justify-between">

                <div className="flex justify-start items-center mt-2 -ml-2 mb-2 w-full">
                    <div className={'text-xl ml-2 w-48'}>
                        Parent Products
                    </div>

                    {allDesignInfo &&
                        <div
                            className={'w-full flex justify-start items-start'}>
                            <DesignInfoFilters
                                dataFetchInProgress={false}
                                allDesignInfo={allDesignInfo}
                                showSecondaryFilters={false}
                                allFilterFields={DESIGN_INFO_FILTER_FIELDS_FOR_PRODUCTS}
                                containerClass={''}
                                fieldClass={'w-fit'}
                                filterCriteria={filterCriteria}
                                setFilterCriteria={setFilterCriteria}/>
                        </div>
                    }

                    <div className="ml-4">
                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                    </div>
                </div>

                {/*<div className="text-center w-1/6 flex items-center justify-end">
                    <div className="ml-2">

                    </div>
                </div>*/}

            </div>

            <div className="flex justify-start mt-4">

                <div className="w-1/4">

                    <div
                        className={'table-container-with-title-2 bg-white overflow-y-scroll border border-gray-400 rounded-lg'}>

                        <ShowEmptyListMessage
                            dataList={parentProductsList}
                            dataFetchInProgress={false}
                            label={'Parent Products'}/>

                        {parentProductsList?.length > 0 &&
                            <table className="w-full">
                                <thead className="">
                                <tr>
                                    <th className="p-2 border-y border-gray-400 bg-gray-400 text-white sticky top-0 w-8">S.No</th>
                                    <th className="p-2 border-y border-gray-400 bg-gray-400 text-white sticky top-0 text-left">Name</th>
                                </tr>
                                </thead>
                                <tbody className="">
                                {parentProductsList?.map((parentProduct, rowIndex) => (
                                    <tr key={`row-${rowIndex}`}
                                        onClick={() => {
                                            setSelectedParentProduct(parentProduct);
                                        }}
                                        className={`border-b border-gray-400 cursor-pointer hover:bg-green-100 ${(selectedParentProduct && selectedParentProduct?.key === parentProduct?.key) ? 'bg-green-200' : ''}`}>
                                        <td className="p-2 m-auto">
                                            <div className="flex justify-center w-8">
                                                {rowIndex + 1}
                                            </div>
                                        </td>

                                        <td className={`p-2 m-auto flex justify-start items-center`}>
                                            <div className={'mr-4'}>
                                                {parentProduct?.label}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        }

                    </div>

                </div>

                <div className={'w-3/4'}>
                    <div className={'mx-4'}>
                        <ShowEmptyListMessage
                            dataList={parentProduct ? [parentProduct] : []}
                            dataFetchInProgress={dataFetchInProgress}
                            label={'Parent Product'}/>

                        {parentProduct &&
                            <ParentProductDetail
                                parentProduct={parentProduct}
                                setParentProduct={setParentProduct}
                                allTags={allTags}/>
                        }
                    </div>
                </div>

            </div>

        </>
    )
}

export default ParentProductsList
